import React from 'react';
import { Card, CardContent } from './card';
import { Crown, Award, TrendingUp } from 'lucide-react';

export const WhyChooseSection = () => {
  const benefits = [
    {
      icon: Award,
      title: "Award-Winning Salon Business",
      description: "Join our established award-winning salon franchise with proven success in hair extensions, hair loss treatments, and specialist hair services."
    },
    {
      icon: Crown,
      title: "Specialist Training & Support",
      description: "Master 18 different hair extension techniques, hair loss treatments, and bespoke solutions with comprehensive training and ongoing support."
    },
    {
      icon: TrendingUp,
      title: "Celebrity & Premium Market",
      description: "Work with celebrities, proms, weddings, and premium clients. Established reputation in TV, film, and theatre industry."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-5xl md:text-6xl font-bold mb-6 text-dark">
            Why Choose Need A Hair Makeover?
          </h2>
          <p className="text-xl text-subtle max-w-3xl mx-auto">
            Join the UK's leading specialist salon franchise for hair extensions and hair loss solutions
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <Card key={index} className="benefit-card group hover:shadow-xl transition-all duration-300 border-2 hover:border-accent-primary/20">
              <CardContent className="p-8 text-center">
                <div className="benefit-icon w-16 h-16 bg-brand-silver-light rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-accent-primary group-hover:scale-110 transition-all duration-300">
                  <benefit.icon className="w-8 h-8 text-accent-primary group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold mb-4 text-dark">{benefit.title}</h3>
                <p className="text-subtle leading-relaxed">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};